import React from "react";
import EditArtworks from "./art/EditArtworks";
import PageEditForms from "./page/PageEditForms";
import Trigger from "./start/Trigger";
import ListEmails from "./emails/ListEmails";

const Home = (): React.JSX.Element => {
  return (
    <section>
      <EditArtworks />
      <PageEditForms />
      <ListEmails />
      <Trigger />
    </section>
  );
};

export default Home;
